<template>
<div class="content">
    <div id="page">
      <div class="page">
        <h1>404 - Not Found</h1>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "p404",
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/404.vue